var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3701_544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.57593 7.36157V11.8157C2.57593 12.2967 2.96555 12.6816 3.44175 12.6816H12.1529C12.6338 12.6816 13.0186 12.292 13.0186 11.8157V7.36157",
    stroke: "#87888C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38745 5.74057L2.37833 2.82084C2.49858 2.4697 2.83048 2.23401 3.20086 2.23401H12.4074C12.7777 2.23401 13.1097 2.4697 13.2299 2.82084L14.2208 5.73576",
    stroke: "#87888C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.586 5.7406C4.586 6.62565 3.86929 7.33755 2.98904 7.33755C2.1088 7.33755 1.39209 6.62087 1.39209 5.7406",
    stroke: "#87888C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79452 5.7406C7.79452 6.62565 7.07783 7.33755 6.19756 7.33755C5.31731 7.33755 4.58618 6.62087 4.58618 5.7406",
    stroke: "#87888C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0028 5.7406C11.0028 6.62565 10.2765 7.33755 9.39137 7.33755C8.50633 7.33755 7.79443 6.62087 7.79443 5.7406",
    stroke: "#87888C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0032 5.7406C11.0032 6.62565 11.7151 7.33755 12.6001 7.33755C13.4852 7.33755 14.197 6.62087 14.197 5.7406",
    stroke: "#87888C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79932 6.72656V12.6815",
    stroke: "#87888C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0231 9.7041H7.79932",
    stroke: "#87888C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3701_544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.804199 0.457764)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.a7cd273486cf6811980d86a8df5f8e73.svg";
export { ForwardRef as ReactComponent };